import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import MarketingLayout from "../layouts/MarketingLayout";
import HomePage from "../pages/home/HomePage";
import ActivityPage from "../pages/activity/ActivityPage";
import ScoreQueryPage from "../pages/score-query/ScoreQueryPage";
import VolunteerPlanningPage from "../pages/volunteer-planning/VolunteerPlanningPage";

const standaloneRoutePrefixes = ["/volunteer-planning", "/score-query", "/activity"];

function AppRouter() {
  const location = useLocation();
  const isStandalone = standaloneRoutePrefixes.some((prefix) =>
    location.pathname.startsWith(prefix),
  );

  if (isStandalone) {
    return (
      <Routes>
        <Route path="/volunteer-planning" element={<VolunteerPlanningPage />} />
        <Route path="/score-query" element={<ScoreQueryPage />} />
        <Route path="/activity" element={<ActivityPage />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route
        path="/"
        element={
          <MarketingLayout>
            <HomePage />
          </MarketingLayout>
        }
      />
    </Routes>
  );
}

export default AppRouter;
